import React from 'react';
import '../../App.css';
import HeroSection from '../HeroSection';
import Cards from '../Cards';
import Footer from '../Footer';
import Card from '../Card';


function Home() {
    return (
        
        <>
        <HeroSection />
        <Cards/>
        <Card/>
        <Footer/>
        </>
    );
}

export default Home;